import { render, staticRenderFns } from "./ComprasWilliam.vue?vue&type=template&id=797743e6&"
import script from "./ComprasWilliam.vue?vue&type=script&lang=js&"
export * from "./ComprasWilliam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports